import { Link } from 'components/UI/Link/Link';

export const ResponseError = () => (
  <div className="subscription-form__error-response">
    <strong>Sorry!</strong> We've recognised some of your details - you may already have an account
    with us. You can manage your preferences by visiting{' '}
    <Link href="/my-account" extendClass="inline-link">
      My Account
    </Link>
    . Alternatively you can{' '}
    <Link href="/my-account/forgot-password" extendClass="inline-link">
      reset your password
    </Link>{' '}
    now.
  </div>
);

export const SectionFooter = () => (
  <div className="subscription-section__footer" data-testid="footer">
    Create an account to purchase tickets online. Please see our 
    <Link extendClass="footer-link" href="/privacy-policy" target="_blank">Privacy Statement</Link> for what this means. Don't want to create an account? Please contact the 
    <Link extendClass="footer-link" href="/contact-us" target="_blank">Box Office</Link> to purchase tickets. 
  </div>
);

export const SuccessHeading = () => <span>Thank you for registering with us</span>;

export const SuccessDescription = () => (
  <span>
    You will now receive pre-sales, special offers and discounts for upcoming shows. To update your
    preferences at any time, log into{' '}
    <Link href="/my-account" extendClass="inline-link">
      My Account
    </Link>
    .
  </span>
);
